module.exports = __webpack_public_path__ + "static/media/googlePin2.0025b2b6.svg";